<template>
  <v-dialog
    v-if="showModal"
    v-model="showModal"
    max-width="1000"
    persistent
  >
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert
          type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">
            Thêm mới chỉ tiêu KPI
            <p class="font-weight-regular font-italic caption ma-0" style="color: rgba(0, 0, 0, 0.87);">*Bạn cần chọn thời gian bắt đầu và kết thúc để lấy thông tin phòng ban</p>
          </template>
          <template v-else>
            Cập nhật chỉ tiêu KPI
          </template>

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="hideModal"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-menu
                ref="datePicker_startAt"
                v-model="datePicker_starAt"
                :close-on-content-click="false"
                :return-value.sync="kpi.startAt"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    rules="required"
                    name="Thời gian bắt đầu"
                  >
                    <v-text-field
                      v-model="kpi.startAt"
                      :error-messages="errors"
                      color="primary"
                      label="Thời gian bắt đầu"
                      prepend-icon="mdi-calendar-outline"
                      readonly
                      v-on="on"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="kpi.startAt"
                  color="primary"
                  :max="kpi.endAt"
                  @change="startAtOnChange"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-menu
                ref="datePicker_endAt"
                v-model="datePicker_endAt"
                :close-on-content-click="false"
                :return-value.sync="kpi.endAt"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    rules="required"
                    name="Thời gian kết thúc"
                  >
                    <v-text-field
                      v-model="kpi.endAt"
                      :error-messages="errors"
                      color="primary"
                      label="Thời gian kết thúc"
                      prepend-icon="mdi-calendar-outline"
                      readonly
                      v-on="on"
                    />
                  </validation-provider>
                </template>
                <v-date-picker
                  v-model="kpi.endAt"
                  v-bind:min="kpi.startAt ? kpi.startAt : ''"
                  color="primary"
                  scrollable
                  @change="endAtOnChange"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required|max:255"
                name="Tên chỉ tiêu"
              >
                <v-text-field
                  v-model="kpi.name"
                  label="Tên chỉ tiêu *"
                  :error-messages="errors"
                  color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Phòng ban áp dụng"
              >
                <v-autocomplete
                  v-model="kpi.departmentIds"
                  :items="departments"
                  :error-messages="errors"
                  item-text="name"
                  item-value="id"
                  label="Phòng ban áp dụng *"
                  color="primary"
                  multiple
                  :disable="loadingDepartment"
                  v-show="showDepartment = true"
                  no-data-text="Không có dữ liệu"
                >
                  <template #prepend-item>
                    <common-select-all
                      v-model="kpi.departmentIds"
                      :item="kpi.departments"
                      :items="departments.map(s => s.id)"
                    />
                  </template>
                
                </v-autocomplete>

              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn
            color="success"
            @click.prevent="handleSubmit(saveKPI)"
          >
            Lưu lại
          </v-btn>
          <v-btn
            class="ml-0"
            color="primary"
            @click="hideModal"
          >
            Hủy bỏ
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { formatDate } from '../../../helpers/utils'
  import TokenService from '../../../helpers/token'
  import * as moment from 'moment'
  const KpiRepository = RepositoryFactory.get('kpi')
  const DepartmentRepository = RepositoryFactory.get('department')
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    data () {
      return {
        datePicker_starAt: false,
        datePicker_endAt: false,
        showModal: false,
        isCreate: true,
        errorMessage: '',
        kpi: {},
        departments: [],
        loadingDepartment: false,
        exceptDepartmentIds: [],
        showDepartment: false,
        minDate: moment().format('YYYY-MM-DD')
      }
    },
    created () {
      Bus.$on('show-kpi-form-modal', (kpi) => {
        this.showModal = true
        this.kpi = _.cloneDeep(kpi)
        this.kpi.startAt = formatDate(kpi.startAt)
        this.kpi.endAt = formatDate(kpi.endAt)
        this.showDepartment = false
        this.exceptDepartmentIds = []
        if (kpi.id) {
          this.isCreate = false
          this.exceptDepartmentIds = _.get(this.kpi, 'departmentIds', [])
          this.showDepartment = true
          this.getDepartmentList()
        } else {
          this.isCreate = true
          this.departments = []
        }
      })
    },
    methods: {
      startAtOnChange () {
        this.$refs.datePicker_startAt.save(this.kpi.startAt);
        this.datePicker_startAt = false;
        this.dateChangeProcess();
      },
      endAtOnChange () {
        this.$refs.datePicker_endAt.save(this.kpi.endAt); 
        this.datePicker_endAt = false;
        this.dateChangeProcess();
      },
      dateChangeProcess () {
        if (this.kpi.startAt === null || this.kpi.startAt === '' || this.kpi.endAt === null || this.kpi.endAt === '') {
          this.showDepartment = false;
          return;
        }
        this.showDepartment = true;
        this.getDepartmentList();
        
      },
      hideModal: function () {
        this.showModal = false
        this.isCreate = true
        this.errorMessage = ''
      },
      async getDepartmentList () {
        this.loadingDepartment = true;
        const response = await DepartmentRepository.list({
          limit: 100,
          startAt: this.kpi.startAt,
          endAt: this.kpi.endAt,
          requestType: 'kpi',
          exceptDepartmentIds: this.exceptDepartmentIds,
        })
        if (_.get(response, 'success', false)) {
          this.departments = _.get(response, 'data')
        }
        this.loadingDepartment = false;
      },
      async saveKPI () {
        if (this.isCreate) {
          const kpiData = {
            name: this.kpi.name,
            departmentIds: this.kpi.departmentIds,
            startAt: formatDate(this.kpi.startAt),
            endAt: formatDate(this.kpi.endAt),
          }
          // const loader = this.$loading.show()
          this.appLoadingData(true)
          const response = await KpiRepository.create(kpiData)
          // loader.hide()
          this.appLoadingData(false)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
              title: 'Thêm KPI thành công',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              Bus.$emit('kpi-list-reload')
            })
          }


        } else {
          const kpiData = {
            name: this.kpi.name,
            departmentIds: this.kpi.departmentIds,
            startAt: formatDate(this.kpi.startAt),
            endAt: formatDate(this.kpi.endAt),
          }
          // const loader = this.$loading.show()
          this.appLoadingData(true)
          const response = await KpiRepository.update(this.kpi.id, kpiData)
          // loader.hide()
          this.appLoadingData(false)
          if (!response.success) {
            this.errorMessage = _.get(response, 'message', '')
          } else {
            this.showModal = false
            this.errorMessage = ''
            this.$swal({
              title: 'Cập nhật KPI thành công',
              confirmButtonText: 'Đồng ý',
            }).then(() => {
              Bus.$emit('kpi-list-reload')
            })
          }
        }
      },
    },
  }
</script>
